import type { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

import {
  FixedNavigationItem,
  type FixedNavigationItemProps,
} from "./FixedNavigationItem";
import type { NavigationStateRecord, NavigationStateKey } from "../../types";
import { getTotalProgressFromStep } from "../../helpers";

export const StepNavigationItem: FC<
  FixedNavigationItemProps & {
    id: NavigationStateKey;
    step?: NavigationStateRecord;
    active: boolean;
  }
> = ({ id, step, active = false, ...props }) => {
  const { t } = useTranslation();
  const disabled = step?.disabled ?? false;

  const progress = step ? getTotalProgressFromStep(step) : undefined;

  return (
    <FixedNavigationItem
      icon={step?.icon}
      tooltip={step?.title ?? t(`menu.${id}`)}
      disabled={disabled}
      active={active}
      progress={progress}
      {...(props as HTMLAttributes<HTMLElement>)}
    />
  );
};
